import axios from 'axios'
import { toast } from 'react-toastify'
import base_url from "../config/base_url"
import handleApiError from './handleApiError'
import i18n from '../i18n'
const Logout = async({openModal  , nav  , setLoader})=>{
  setLoader(true)
  try{
     const res = await axios.post(`${base_url}/auth/logout`)
      if(localStorage.getItem("token")){
        localStorage.removeItem("token")
        localStorage.removeItem("userData")
        toast.success(i18n.t('logoutSuccess'))
        nav('/login' , {state:{logout:true , msg:i18n.t('logoutSuccess')}})
      }else{
        toast.warn(i18n.t('alreadyLogout'))
      }
    
  }
  catch(error){
    handleApiError()
  }
  finally{
    openModal(false)
    setLoader(false)
  }
}
export default Logout